import React from 'react';

const Footer = () => {
    return (
      <footer>
         <div className="copyrights flex centered">
            <p>&copy;2024 aclcf - All rights reserved</p>   
            <div className="powered flex centered">
                <h5>Powered by </h5>
                <a href="https://cloudevo.ai/">
                    <img src="img/cloudevo-1.svg" alt="cloudevo"></img>
                </a>
            </div>
         </div>
      </footer>
    );
  };
  
  export default Footer;